import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import { getActivityInformations } from '@/api/common';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { computed, onMounted, ref } from 'vue';
import { checkinRewardClaim } from '@/api/activity';
import CheckinRewardsOne from '@/themes/themeOne/checkinRewards/checkinRewards.vue';
import CheckinRewardsTwo from '@/themes/themeTwo/checkinRewards/checkinRewards.vue';
import checkinRewardsThree from '@/themes/themeThree/checkinRewards/checkinRewards.vue';
import checkinRewardsFour from '@/themes/themeFour/checkinRewards/checkinRewards.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { CheckingRewardData } from './checkinRewards';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'checkinRewards',
  setup(__props) {

const themeStore = useThemeStore()
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const activityInfo = ref([])
const checkinRef = ref()

const isPhoneVerified = ref(false)
const notVerifyConfig = ref<any>({})
const verifyConfig = ref<any>({})
const popverifyType = ref(0)
const bannerIcon = ref('')
const isShowPhoneVerification = ref(false)
const hasNotVerifyData = ref(false)
const hasVerifyPhoneData = ref(false)

const dataSet = computed<CheckingRewardData>(() => ({
    isPhoneVerified: isPhoneVerified.value,
    notVerifyConfig: notVerifyConfig.value,
    verifyConfig: verifyConfig.value,
    popverifyType: popverifyType.value,
    bannerIcon: bannerIcon.value,
    isShowPhoneVerification: isShowPhoneVerification.value,
    hasNotVerifyData: hasNotVerifyData.value,
    hasVerifyPhoneData: hasVerifyPhoneData.value,
    activityInfo: activityInfo.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "signin_rewards",
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        bannerIcon.value = res.data?.floatIcon
        activityInfo.value = JSON.parse(res.data?.activityIntro);
        notVerifyConfig.value = res.data?.config?.not_verify_config || {}
        verifyConfig.value = res.data?.config?.phone_verify_config || {}
        isPhoneVerified.value = res.data?.isPhoneVerified === 1 ? true : false
        isShowPhoneVerification.value = (res.data?.config?.is_sms_verify === 1 || res.data?.config?.is_whatsapp_verify === 1) ? true : false

        if (notVerifyConfig.value?.days == 0 && notVerifyConfig.value?.reward == 0) {
            hasNotVerifyData.value = false
        } else {
            hasNotVerifyData.value = true
        }

        if (verifyConfig.value?.days == 0 && verifyConfig.value?.reward == 0) {
            hasVerifyPhoneData.value = false
        } else {
            hasVerifyPhoneData.value = true
        }

        if (popverifyType.value === 1) {
            checkinRef.value.checkinclose()
            setTimeout(() => {
                callCheckinClaim(verifyConfig.value, 2)
            }, 100)
        }
        if (isPhoneVerified.value) {
            callCheckinClaim(verifyConfig.value, 2)
        } else {
            callCheckinClaim(notVerifyConfig.value, 1)
        }

    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const callCheckinClaim = (configData: any, claimType: number) => {
    if (claimType == 1 && isPhoneVerified.value) {
        console.log('');
    } else {
        loadingRef.value.open()
        let data = {
            type: claimType,
        }
        checkinRewardClaim(data).then(res => {
            loadingRef.value.close()
            openCheckinPopup(configData, claimType)
        }).catch(err => {
            loadingRef.value.close()
            showError(err);
        })
    }
}

const openCheckinPopup = (data: any, type: number) => {
    if (type === 2) {
        checkinRef.value.checkinOpen(data, isPhoneVerified.value)
    } else if (type === 1) {
        if (!isPhoneVerified.value) {
            checkinRef.value.checkinOpen(data, isPhoneVerified.value)
        }
    }
}
const goToVerifyPhoneNum = (type: any) => {
    checkinRef.value.openVerifyPhonePopup()
    if (type == 1) {
        popverifyType.value = 1
    }
}
const updateInfo = () => {
    getActivityInfo()
}
onMounted(() => {
    getActivityInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CheckinRewardsOne, {
            ref_key: "checkinRef",
            ref: checkinRef,
            "data-set": dataSet.value,
            onUpdateInfo: updateInfo,
            onCallCheckinClaim: callCheckinClaim,
            onGoToVerifyPhoneNum: goToVerifyPhoneNum
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CheckinRewardsTwo, {
            ref_key: "checkinRef",
            ref: checkinRef,
            "data-set": dataSet.value,
            onUpdateInfo: updateInfo,
            onCallCheckinClaim: callCheckinClaim,
            onGoToVerifyPhoneNum: goToVerifyPhoneNum
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(checkinRewardsThree, {
            ref_key: "checkinRef",
            ref: checkinRef,
            "data-set": dataSet.value,
            onUpdateInfo: updateInfo,
            onCallCheckinClaim: callCheckinClaim,
            onGoToVerifyPhoneNum: goToVerifyPhoneNum
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(checkinRewardsFour, {
            ref_key: "checkinRef",
            ref: checkinRef,
            "data-set": dataSet.value,
            onUpdateInfo: updateInfo,
            onCallCheckinClaim: callCheckinClaim,
            onGoToVerifyPhoneNum: goToVerifyPhoneNum
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})